<div class="main" [class.main--drawer-open]="isDrawerOpen()">
  <header>
    <app-header [isOpenSearch]="true" />
  </header>
  <div
    class="main-content"
    [ngClass]="{
      'response-view-container': showResponseView(),
    }"
  >
    <div class="mb-3 back-button" [ngClass]="showAllResults() ? ['container', 'results'] : null">
      @if (showAllResults() || showResponseView()) {
        <div class="flex flex-justify-between">
          <button
            mat-button
            class="button-s"
            data-fs-element="Open-Search-Button-Back-To-Main"
            (click)="onBackToMainView()"
          >
            <mat-icon class="icon">arrow_back_ios</mat-icon>
            {{ 'LESSONS.HEADER.BACK' | translate }}
          </button>
          @if (historyResponse()) {
            <app-search-keyword (scrollToText)="onScrollToText($event)"></app-search-keyword>
          }
        </div>
      }
      @if (showAllResults()) {
        <div>
          <h1 class="flex flex-center title-large bold mb-05">
            <mat-icon
              class="icon-m mr-1"
              [fontIcon]="searchType() === quick() ? 'auto_awesome' : 'bookmark'"
            ></mat-icon>
            {{
              searchType() === quick()
                ? ('OPEN_SEARCH.QUICK_SEARCH' | translate)
                : ('OPEN_SEARCH.RECENT_SEARCH' | translate)
            }}
          </h1>
          <p *ngIf="searchType() === quick()" class="body-large">
            {{ 'OPEN_SEARCH.OPTIMIZED_PROMPTS_INFO' | translate }}
          </p>
          <p *ngIf="searchType() === recent()" class="body-large">
            {{ 'OPEN_SEARCH.RECENT_SEARCH_INFO' | translate }}
          </p>
        </div>
      }
    </div>

    @if (!showResponseView()) {
      <section class="container full-width mt-3 mb-3" *ngIf="!showAllResults()">
        <div class="container-user">
          <h1 class="headline-medium semi-bold color-primary">
            {{ 'HOME.MAIN.GREETING' | translate }}
          </h1>
          @if (user()?.photo) {
            <img class="avatar" [src]="user()?.photo" alt="User Photo" />
          }
          @if (!user()?.photo) {
            <div class="avatar initials-avatar">
              {{ user()?.initials }}
            </div>
          }
          <h1 class="headline-medium semi-bold color-primary">{{ firstName() }}!</h1>
        </div>
        <div class="container-title">
          <h2 class="h4-title-large-semibold mt-1">
            {{ 'OPEN_SEARCH.EXPLORE_ASSISTANT' | translate }}
          </h2>
          <h4 class="title-medium mt-1">
            {{ 'OPEN_SEARCH.EXPLORE_ASSISTANT_EXPLAIN' | translate }}
          </h4>
        </div>
      </section>

      <section
        class="container overflow-hidden flex flex-column"
        [ngClass]="{
          'flex-1': !showAllResults() && (showRecentSearchPanel() || showQuickSearchPanel()),
          results: showAllResults(),
        }"
      >
        <div class="input-container" [ngClass]="[!showAllResults() ? 'search--full' : '']">
          @if (!(searchType() === recent() && showAllResults())) {
            <app-textarea-search
              id="open-search-input"
              data-fs-element="Open-Search-Input-Search"
              [(showAllResults)]="showAllResults"
              [(inputText)]="inputText"
              [(queryMode)]="queryMode"
              [(searchType)]="searchType"
              [(items)]="items"
              [(showResponseView)]="showResponseView"
              [(activeDestroyComponent)]="activeDestroyComponent"
            />
          }
          @if (!showAllResults()) {
            <div class="search-type-container">
              <!-- <button
                class="query-mode-trigger"
                data-fs-element="Open-Search-Button-Query-Mode-Main"
                [class.query-mode-trigger--selected]="queryMode() === 'curated-lessons'"
                [matMenuTriggerFor]="queryModesMenu"
                #queryModesMenuTrigger="matMenuTrigger"
                [attr.aria-label]="'OPEN_SEARCH.QUERY_MODES' | translate"
              >
                <span class="query-mode-icon-container" aria-hidden="true">
                  @if (queryMode() === 'curated-lessons') {
                    <img
                      class="query-mode-icon"
                      src="/images/icons/query-mode-folder-special.svg"
                      alt=""
                    />
                  } @else {
                    <img
                      class="query-mode-icon"
                      src="/images/icons/query-mode-dashboard.svg"
                      alt=""
                    />
                  }
                </span>
                <span
                  class="query-mode-label body-medium"
                  [class.bold]="queryMode() === 'curated-lessons'"
                >
                  {{
                    (queryMode() === 'curated-lessons'
                      ? 'OPEN_SEARCH.CURATED_LESSONS_SELECTED'
                      : 'OPEN_SEARCH.QUERY_MODES'
                    ) | translate
                  }}
                </span>
                <mat-divider vertical></mat-divider>
                <mat-icon
                  class="query-mode-arrow"
                  [fontIcon]="
                    queryModesMenuTrigger.menuOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                  "
                ></mat-icon>
              </button> -->
              <div class="icon-button">
                <div class="button-quick">
                  <button
                    mat-icon-button
                    class="icon-button-s"
                    [matTooltip]="'OPEN_SEARCH.QUICK_SEARCH' | translate"
                    id="quick-search-button"
                    data-fs-element="Open-Search-Button-Quick-Search"
                    [ngClass]="{ active: searchType() === quick() }"
                    (click)="openQuickSearch()"
                  >
                    <mat-icon fontIcon="auto_awesome" class="icon-m"></mat-icon>
                  </button>
                </div>
                <mat-divider vertical style="height: 12px" class=""></mat-divider>
                <div class="button-quick">
                  <button
                    mat-icon-button
                    class="icon-button-s"
                    [matTooltip]="'OPEN_SEARCH.RECENT_SEARCH' | translate"
                    id="recent-search-button"
                    data-fs-element="Open-Search-Button-Recent-Search"
                    [ngClass]="{ active: searchType() === recent() }"
                    (click)="openRecentSearch()"
                  >
                    <mat-icon fontIcon="bookmark" class="icon-s"></mat-icon>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </section>
    }
    @if (showAllResults()) {
      <section
        class="container mb-3 flex flex-1 overflow-hidden w-100"
        [ngClass]="{ results: showAllResults(), 'mt-3': showAllResults() }"
      >
        <app-search-panel
          *ngIf="searchType() === quick()"
          [searchType]="quick()"
          [(items)]="items"
          [showAll]="true"
          [(showAllResults)]="showAllResults"
          [(showSearchPanel)]="showSearchPanel"
          [(isShowAllResults)]="isShowAllResults"
        />
        <app-search-panel
          *ngIf="searchType() === recent()"
          [searchType]="recent()"
          [(items)]="items"
          [showAll]="true"
          [(showAllResults)]="showAllResults"
          [(showSearchPanel)]="showSearchPanel"
          [(isShowAllResults)]="isShowAllResults"
        />
      </section>
    }
    @if (showResponseView()) {
      <app-response-view
        [(activeDestroyComponent)]="activeDestroyComponent"
        [(inputText)]="inputText"
        [(items)]="items"
        [(showSearchPanel)]="showSearchPanel"
        [(isShowAllResults)]="isShowAllResults"
        [(searchType)]="searchType"
        [(queryMode)]="queryMode"
      />
    }
    @if (!showResponseView() && !showAllResults() && showDisclaimer()) {
      <div class="container mt-9">
        <div class="disclaimer-header flex flex-justify-right">
          <button
            mat-icon-button
            class="icon-button-s"
            [matMenuTriggerFor]="disclaimerMenu"
            #disclaimerMenuTrigger="matMenuTrigger"
            aria-label="Hide disclaimer options"
            data-fs-element="Open-Search-Button-Open-Disclaimer-Options"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="disclaimer">
          <div class="disclaimer-cards">
            <div class="card">
              <div class="card-header">
                <mat-icon class="location" fontIcon="my_location"></mat-icon>

                <h4 class="body-large-bold">
                  {{ 'DISCLAIMER.HOW_IT_HELPS_TITLE' | translate }}
                </h4>
              </div>

              <p class="body-medium">
                {{ 'DISCLAIMER.HOW_IT_HELPS_TEXT' | translate }}
              </p>
            </div>

            <mat-divider vertical style="height: 160px"></mat-divider>

            <div class="card">
              <div class="card-header">
                <mat-icon
                  class="library material-symbols-outlined"
                  fontIcon="local_library"
                ></mat-icon>

                <h4 class="body-large-bold">
                  {{ 'DISCLAIMER.WHAT_YOU_CAN_EXPLORE_TITLE' | translate }}
                </h4>
              </div>

              <p class="body-medium">
                {{ 'DISCLAIMER.WHAT_YOU_CAN_EXPLORE_TEXT' | translate }}
              </p>
            </div>

            <mat-divider vertical style="height: 160px"></mat-divider>

            <div class="card">
              <div class="card-header">
                <mat-icon
                  class="food material-symbols-outlined"
                  fontIcon="emoji_food_beverage"
                ></mat-icon>

                <h4 class="body-large-bold">
                  {{ 'DISCLAIMER.COMING_NEXT_TITLE' | translate }}
                </h4>
              </div>

              <p class="body-medium">
                {{ 'DISCLAIMER.COMING_NEXT_TEXT' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <mat-menu #disclaimerMenu="matMenu" class="disclaimer-menu" xPosition="before">
        <div class="menu-content pl-3 pr-3 pb-3 pt-2">
          <div class="flex flex-justify-between flex-center">
            <h4 class="h4-title-large-semibold flex flex-center">
              <mat-icon class="mr-2 primary" fontIcon="my_location"></mat-icon>
              {{ 'DISCLAIMER.VISIBILITY_MENU_TITLE' | translate }}
            </h4>

            <button
              mat-icon-button
              (click)="disclaimerMenuTrigger.closeMenu()"
              aria-label="Close tips popover"
              data-fs-element="Open-Search-Button-Close-Disclaimer-Options"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <p class="body-large mt-4 mb-2">
            {{ 'DISCLAIMER.VISIBILITY_MENU_TEXT' | translate }}
          </p>

          <div class="flex flex-center flex-justify-right pt-2">
            <button
              mat-stroked-button
              (click)="onHideDisclaimerForever(); disclaimerMenuTrigger.closeMenu()"
              class="mr-2"
              data-fs-element="Open-Search-Button-Hide-Disclaimer-Forever"
            >
              {{ 'DISCLAIMER.HIDE_FOREVER' | translate }}
            </button>

            <button
              mat-flat-button
              data-fs-element="Open-Search-Button-Hide-Disclaimer-Now"
              (click)="onHideDisclaimerForNow(); disclaimerMenuTrigger.closeMenu()"
            >
              {{ 'DISCLAIMER.HIDE_FOR_NOW' | translate }}
            </button>
          </div>
        </div>
      </mat-menu>
    }
  </div>
  <mat-menu #queryModesMenu="matMenu" class="query-mode-menu">
    <button
      mat-menu-item
      class="query-mode-menu-item query-mode-menu-item--curated label-medium-semibold"
      data-fs-element="Open-Search-Button-Query-Mode-Curated-Lessons-Main"
      (click)="queryMode.set('curated-lessons')"
    >
      <span class="query-mode-menu-icon-container" aria-hidden="true">
        <img
          class="query-mode-menu-icon"
          src="/images/icons/query-mode-folder-special.svg"
          alt=""
        />
      </span>
      <span>{{ 'OPEN_SEARCH.CURATED_LESSONS_OPTION' | translate }}</span>
    </button>
    <button
      mat-menu-item
      class="query-mode-menu-item query-mode-menu-item--default"
      data-fs-element="Open-Search-Button-Query-Mode-Default-Main"
      (click)="queryMode.set('default')"
    >
      <span class="query-mode-menu-icon-container" aria-hidden="true">
        <img class="query-mode-menu-icon" src="/images/icons/query-mode-dashboard.svg" alt="" />
      </span>
      <span>{{ 'OPEN_SEARCH.QUERY_MODES' | translate }}</span>
    </button>
  </mat-menu>
  @if (!showResponseView()) {
    <footer class="footer">
      <div class="container">
        <div class="text-disclaimer mt-2 mb-5">
          <p class="body-large-bold">{{ 'DISCLAIMER.STAY_CURIOUS_TEXT' | translate }}</p>
          <p class="body-large">
            {{ 'DISCLAIMER.HELP_US_IMPROVE_TEXT' | translate }}
            <a class="url" href="mailto:knowledgeplatform@iadb.org">
              knowledgeplatform&#64;iadb.org
            </a>
          </p>
        </div>
      </div>
      <app-footer></app-footer>
    </footer>
  }
</div>
